import React from "react";
import { Surface, Symbols } from "recharts";
import { Box } from "../Box";
import { Flex } from "../Flex";
/**
 * Checks if a pie chart data object has any non-zero values
 * @param {Object} data - Object containing pie chart data where each key has a value property
 * @returns {boolean} True if any data point has a value greater than 0, false otherwise
 * @example
 * const data = {
 *   slice1: { value: 0 },
 *   slice2: { value: 5 }
 * };
 * doesPieChartHaveData(data); // Returns true
 */
export const doesPieChartHaveData = (data) => {
    const result = Object.keys(data).find((key) => data[key].value > 0);
    return !!result;
};
export const formattedLegendText = ({ props, chartColors }) => {
    const { payload } = props;
    return (React.createElement(Flex, { "data-testid": "formattedLegendText", justifyContent: "center", sx: { flexWrap: "wrap", padding: "8px", paddingTop: "16px" }, width: "100%" }, payload.map((entry, index) => (React.createElement(Flex, { as: "span", "data-testid": "formattedLegendPayload", key: `overlay-${index}`, sx: { alignItems: "center", gap: "2px" } },
        React.createElement(Surface, { width: 20, height: 20 },
            React.createElement(Symbols, { cx: 10, cy: 10, type: "circle", size: 100, fill: entry.color })),
        React.createElement(Box, { as: "span", sx: { color: chartColors.legendText } }, entry.value))))));
};
export const getDataFillColor = ({ entry, index, isRiskChart, theme }) => {
    if (isRiskChart) {
        switch (entry.name) {
            case "Critical":
                return theme.colors.chartColors.risk.critical;
            case "High":
                return theme.colors.chartColors.risk.high;
            case "Medium":
                return theme.colors.chartColors.risk.medium;
            case "Low":
                return theme.colors.chartColors.risk.low;
            case "Alert":
                return theme.colors.chartColors.risk.alert;
            case "Safe":
                return theme.colors.chartColors.risk.safe;
            default:
                return theme.colors.chartColors.risk.default;
        }
    }
    return theme.colors.chartColors.colors[index % theme.colors.chartColors.colors.length];
};
export var RiskLevel;
(function (RiskLevel) {
    RiskLevel["Critical"] = "Critical";
    RiskLevel["High"] = "High";
    RiskLevel["Medium"] = "Medium";
    RiskLevel["Low"] = "Low";
    RiskLevel["Alert"] = "Alert";
    RiskLevel["Safe"] = "Safe";
})(RiskLevel || (RiskLevel = {}));
/* eslint-disable sort-keys-fix/sort-keys-fix */
export const TRANSLATERISKS = {
    undefined: -3,
    Safe: -2,
    Low: 0,
    Medium: 1,
    High: 2,
    Critical: 3,
    Alert: 4,
};
